import logoImg from "../assets/logo.png";

export function Logo({ className }) {
  return (
    <img
      src={logoImg}
      alt="TitanSkip"
      className={`h-7 w-auto ${className ?? ""}`}
    />
  );
}
